
















































import { Component, Vue } from "vue-property-decorator";
import { Icon, Empty } from "vant";

@Component({
  components: {
    [Icon.name]: Icon,
    [Empty.name]: Empty
  }
})
export default class TransferIntoHKIndex extends Vue {
  cardList = [];
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getBankList();
  }

  /**
   * 获取转入资金银行列表
   */
  getBankList() {
    (this as any).$apis
      .getRemittanceList({
        account_type:this.$route.query.account_type || this.$route.query.account_type
      })
      .then(res => {
        this.requestFail = false;
        this.cardList = res;
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  /**
   * 跳转至银行对应的汇款对照信息页面
   * @param item {Object} 银行卡项信息
   */
  jumpToBankDetail(item) {
    this.$router.push({
      name: "transfer-into-abroad",
      query: { ...this.$route.query, id: item.id }
    });
  }
}
